"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.WalletApi = void 0;
var tslib_1 = require("tslib");
/* eslint-disable */
/* 此代码由工具自动生成,不要直接修改,以免下次生成会丢失 */
var di_1 = tslib_1.__importDefault(require("@jsmodules/di"));
var getApi_1 = tslib_1.__importDefault(require("../../getApi"));
var WalletApi = /** @class */ (function () {
    function WalletApi() {
        this.http = getApi_1.default('api_v1');
    }
    /**
     * 查询提现申请
     * @method GET 查询提现申请
     *
     */
    WalletApi.prototype.withdraw = function () {
        return this.http
            .url("/api/Wallet/wallet/withdraw")
            .addSecurityHeaders()
            .support('GET');
    };
    /**
     * 确认提现
     * @method POST 确认提现
     *
     * @params id 无说明
     */
    WalletApi.prototype.confirm = function (id) {
        return this.http
            .url("/api/Wallet/wallet/withdraw/" + id + "/confirm")
            .addSecurityHeaders()
            .support('POST');
    };
    /**
     * 驳回提现
     * @method POST 驳回提现
     *
     * @params id 无说明
     */
    WalletApi.prototype.decline = function (id) {
        return this.http
            .url("/api/Wallet/wallet/withdraw/" + id + "/decline")
            .addSecurityHeaders()
            .support('POST');
    };
    WalletApi.diOptions = di_1.default.options({
        name: "WalletApi",
        scope: "Singleton"
    });
    return WalletApi;
}());
exports.WalletApi = WalletApi;
exports.default = WalletApi;
